import React from 'react'
import className from 'classnames/bind'

import style from './MyhousePriceEmpty.module.scss'

import { handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  articleMoreHandler?: any
}

const MyhousePriceEmpty: React.FC<Props> = ({ articleMoreHandler }: Props) => {
  const url = '#'
  return (
    <div className={cx('article')}>
      <span className={cx('text')}>시세 정보가 없습니다.</span>
      <p className={cx('description')}>불러올 수 있는 실거래 내역 및 시세 정보가 없습니다. 우리집 외의 더 많은 매물 정보를 확인하고 싶다면 지도로 이동해 보세요.</p>
      <a href={url} className={cx('link')} onClick={handleNclickMix(NCLICK.MY_HOUSE.NOT_PRICE_MORE, articleMoreHandler)}>
        지도에서 다른 매물 정보 찾아보기
      </a>
    </div>
  )
}

export default MyhousePriceEmpty
